<template>
  <div
    class="shrink-0 flex relative transition-[width]"

    @mouseover="hoveringSidebar = true"
    @mouseleave="hoveringSidebar = false"
  >
    <transition
      @enter="enter"
      @leave="leave"

      enter-active-class="overflow-hidden"
      leave-active-class="overflow-hidden"
    >
      <div v-show="!hideNavigation" class="grow flex">
        <MaInNavigationSidebar
          class="pt-6"
          v-model="activeSidebar"
          :locked="locked"

          :translationRequiresAttention="translationRequiresAttention"
          :triggerTemplateImport="triggerTemplateImport"
          @reseted-all-changes="resetColorChanges"
          @toggle-locked="locked = !locked"
        />
      </div>
    </transition>
    <slot name="before-sidebar"></slot>

    <transition
      @enter="enter"
      @leave="leave"

      enter-active-class="overflow-hidden"
      leave-active-class="overflow-hidden"
    >
      <div v-show="showingSidebar" class="flex ease-in-out duration-100">
        <div v-if="page" ref="wrapper" class="flex">
          <transition
            mode="out-in"

            @before-leave="snapshotWidth"
            @enter="startAnimation"

            :css="false"
          >
            <keep-alive>
              <BlocksSidebar v-if="activeSidebar === 'blocks'" class="shrink-0" key="blocks" @trigger-template-import="triggerTemplateImport = !triggerTemplateImport"/>
              <StylesMenu v-else-if="activeSidebar === 'styles'" class="w-96 pt-1 border-r border-gray-200" key="styles"/>
              <GlobalTranslationsTable
                v-else-if="activeSidebar === 'translation'"

                :loading="loadingKeys"
                :requiresAttention="translationRequiresAttention"
                :initial-translations="globalTranslations"
                :keys="keys"
                class="w-[45em] border-r border-gray-200"
              />
            </keep-alive>
          </transition>
        </div>
      </div>
    </transition>

    <portal-target name="magento-sidebar"></portal-target>
    <slot name="after-sidebar"></slot>

    <UneditableWhenEmptyConfig/>
  </div>
</template>

<script>

import BlocksSidebar from "../BlocksSidebar/BlocksSidebar.vue"
import MaInNavigationSidebar from "@/components/SideEditor/MainNavigation/MaInNavigationSidebar"
import StylesMenu from "@/components/SideEditor/StylesMenu"
import GlobalTranslationsTable from "@/components/SideEditor/GlobalTranslationsTable/GlobalTranslationsTable"
import UneditableWhenEmptyConfig from "@/components/SideEditor/UneditableWhenEmptyConfig"

import { mapGetters } from "vuex"
import transitionFunctionConstructor from "@/mixins/transitionFunctionConstructor"

export default {
  props: ['page', 'hideNavigation'],
  mixins: [transitionFunctionConstructor('enter', 'leave', 'width')],
  components: {
    UneditableWhenEmptyConfig,
    BlocksSidebar,
    MaInNavigationSidebar,
    StylesMenu,
    GlobalTranslationsTable,
  },
  data() {
    return {
      activeSidebar: 'blocks',
      widthSnapshot: null,
      keys: [],
      loadingKeys: false,
      triggerTemplateImport: false,

      hoveringSidebar: false,
      locked: localStorage.getItem('sidebar_locked') || true,
    }
  },
  created() {
    this.readyToLoad && this.loadKeys()
  },
  methods: {
    async loadKeys() {
      this.loading = true

      let str = '?&'
      this.availablePackages.forEach(pack => str += `packages[]=${pack.module_id}&`)
      this.allBlocks.forEach(blockId => str += `blocks[]=${blockId}&`)
      this.keys = await (await fetch(`${this.domain}/rest/V1/editor/list-translation-keys${str}`, {
        headers: { Cookie: 'environment=editor' },
      })).json()

      this.loading = false
    },

    snapshotWidth() {
      this.widthSnapshot = this.$refs.wrapper.getBoundingClientRect().width
    },
    startAnimation(el, done) {
      const width = el.getBoundingClientRect().width
      if (width === this.widthSnapshot) return done()

      const wrapper = this.$refs.wrapper.children[0]

      wrapper.style.width = this.widthSnapshot + "px"
      wrapper.classList.remove("transition-[width,opacity]")
      requestAnimationFrame(() => {
        wrapper.style.width = width + "px"
        wrapper.classList.add("transition-[width,opacity]")

        setTimeout(() => {
          requestAnimationFrame(() => {
            wrapper.style.width = ""
            done()
          })
        }, 160)
      })
    },
    resetColorChanges() {
      this.$store.commit("editor/resetColorConfig")
      this.swatch = false
      this.resetingColorSwatch = true
      this.$nextTick(() => {
        this.swatch = true
        this.$nextTick(() => this.resetingColorSwatch = false)
      })
    },
  },
  computed: {
    ...mapGetters({
      availablePackages: 'editor/availablePackages',
      domain: 'editor/fullDomainLink',
      config: 'editor/config',
      blocks: 'editor/blocksCollection',
      emptyConfig: 'editor/emptyConfig',
    }),

    showingSidebar() {
      return (this.locked || this.hoveringSidebar) && !this.emptyConfig
    },
    readyToLoad() {
      return this.availablePackages.length && this.domain
    },
    globalTranslations() {
      const config = this.config
      return config ? config.translations || null : null
    },
    translationRequiresAttention() {
      return this.keys.length > Object.keys(this.globalTranslations || {}).length
    },
    allBlocks() {
      const blockIds = []
      const blocks = this.blocks

      Object.keys(blocks).forEach(page => {
        Object.keys(blocks[page]).forEach(role => {
          blocks[page][role].forEach(block => {
            const blockId = block.id.includes("_") ? block.id.split("_")[0] : block.id
            if (!blockIds.includes(blockId)) blockIds.push(blockId)
          })
        })
      })

      return blockIds
    },
  },
  watch: {
    locked(locked) {
      localStorage.setItem('sidebar_locked', locked)
    },
    readyToLoad(load) {
      load && this.loadKeys()
    },
  },
}

</script>
